// A tab left open across a deploy still runs the old bundle, whose lazily
// imported chunks (e.g. Capacitor plugins' `web-*.js` implementations) no
// longer exist on the server. Vite fires `vite:preloadError` when such an
// import fails; reloading picks up the new build. The timestamp guard stops a
// reload loop if the chunk is genuinely broken, while still letting the same
// tab recover from a later deploy.
const RELOADED_AT_KEY = "stale-chunk-reloaded-at";
const MIN_RELOAD_INTERVAL_MS = 60_000;

const readReloadedAt = (): number => {
  try {
    return Number(window.sessionStorage.getItem(RELOADED_AT_KEY)) || 0;
  } catch {
    return 0;
  }
};

const writeReloadedAt = (value: number) => {
  try {
    window.sessionStorage.setItem(RELOADED_AT_KEY, String(value));
  } catch {
    // Storage unavailable (private mode etc.) — reload anyway
  }
};

export const registerStaleChunkReload = () => {
  window.addEventListener("vite:preloadError", (event) => {
    const now = Date.now();
    if (now - readReloadedAt() < MIN_RELOAD_INTERVAL_MS) {
      // Already reloaded recently and it failed again — let the error surface
      return;
    }
    // eslint-disable-next-line no-console
    console.warn("Reloading after failed chunk import", event);
    writeReloadedAt(now);
    window.location.reload();
  });
};
